import { usePermissions } from "react-admin";
import { Alert, Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getDashboardItemsCount } from "../../helpers/adminQueries";
import "./style.css";

interface ICounts {
  approvalsCount: number;
  businessPlansCount: number;
  companiesCount: number;
}

const Dashboard = () => {
  const { permissions } = usePermissions();
  const system = permissions?.role === "SYSTEM_ADMIN";
  const [counts, setCounts] = useState<ICounts | null>(null);

  useEffect(() => {
    if (permissions?.role === "ADMIN") {
      getDashboardItemsCount().then((data) => {
        setCounts(data || null);
      });
    }
  }, [permissions?.role]);

  if (system)
    return (
      <Box sx={{ p: 4, maxWidth: 900 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Systemadministration
        </Typography>
        <Alert severity="info">
          Her administrerer du modultildeling til netværk. Virksomhedsdata vises
          ikke.
        </Alert>
      </Box>
    );

  return (
    <div className="dashboard">
      <h2>Dashboard</h2>
      <div className="dashboard-wrap">
        <div className="dashboard-item">
          <h4>Approvals</h4>
          <span>{counts?.approvalsCount || 0}</span>
        </div>
        <div className="dashboard-item">
          <h4>Registered Companies</h4>
          <span>{counts?.companiesCount || 0}</span>
        </div>
        <div className="dashboard-item">
          <h4>Business plans</h4>
          <span>{counts?.businessPlansCount || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
